import { fetch } from '../utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryRingSizers(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-ring-sizer`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

export default {};
